"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _fuseUtils = require("@tvg/fuse-utils");
var _styledPrice = require("./styled-price");
var _config = require("./config");
var _excluded = ["price", "dataTestId", "headingTag", "isEuro", "prevPrice", "saving", "showCurrentFrom", "showPreviousFrom", "showSave", "size"];
/* Price */
/* Displays a price. This includes sale and range */
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var forwardRef = _react["default"].forwardRef;
var propTypes = {
  price: _propTypes["default"].number.isRequired,
  dataTestId: _propTypes["default"].string,
  headingTag: _propTypes["default"].string,
  isEuro: _propTypes["default"].bool,
  prevPrice: _propTypes["default"].number,
  saving: _propTypes["default"].number,
  showCurrentFrom: _propTypes["default"].bool,
  showPreviousFrom: _propTypes["default"].bool,
  showSave: _propTypes["default"].bool,
  size: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['xxs', 'xs', 's', 'm', 'l']), _propTypes["default"].shape({
    xxs: _propTypes["default"].string,
    xs: _propTypes["default"].string,
    s: _propTypes["default"].string,
    m: _propTypes["default"].string,
    l: _propTypes["default"].string,
    xl: _propTypes["default"].string,
    xxl: _propTypes["default"].string
  })])
};
var defaultProps = {
  dataTestId: null,
  headingTag: 'h3',
  isEuro: false,
  prevPrice: 0,
  saving: 0,
  showCurrentFrom: false,
  showPreviousFrom: false,
  showSave: true,
  size: 'l'
};
var basicPriceConfig = _config.priceConfig.basicPrice,
  prevPriceConfig = _config.priceConfig.prevPrice,
  savePriceConfig = _config.priceConfig.savePrice;
var Price = forwardRef(function (_ref, ref) {
  var price = _ref.price,
    dataTestId = _ref.dataTestId,
    headingTag = _ref.headingTag,
    isEuro = _ref.isEuro,
    prevPrice = _ref.prevPrice,
    saving = _ref.saving,
    showCurrentFrom = _ref.showCurrentFrom,
    showPreviousFrom = _ref.showPreviousFrom,
    showSave = _ref.showSave,
    size = _ref.size,
    others = _objectWithoutProperties(_ref, _excluded);
  var formattedPrice = (0, _fuseUtils.formatPrice)(price);
  var formattedPrevPrice = (0, _fuseUtils.formatPrice)(prevPrice);
  var formattedSavePrice = (0, _fuseUtils.formatPrice)(saving);
  var _buildResponsiveSize = (0, _fuseUtils.buildResponsiveSize)(size),
    _buildResponsiveSize2 = _slicedToArray(_buildResponsiveSize, 1),
    isResponsive = _buildResponsiveSize2[0];
  var getResponsiveFontSize = function getResponsiveFontSize(config) {
    if (isResponsive) {
      var processedSize = {};
      Object.keys(size).forEach(function (viewport) {
        processedSize[viewport] = config.font.size[size[viewport]];
      });
      return processedSize;
    }
    return config.font.size[size];
  };
  var getPriceText = function getPriceText(priceNum, showFrom) {
    var isSave = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var saveText = showFrom ? 'Save up to ' : 'Save ';
    var fromText = showFrom ? 'From ' : '';
    var currency = isEuro ? '€' : '£';
    var prefix = isSave ? saveText : fromText;
    return "".concat(prefix).concat(currency).concat(priceNum);
  };
  return /*#__PURE__*/_react["default"].createElement(_styledPrice.StyledPriceContainer, _extends({
    "data-testid": dataTestId,
    ref: ref
  }, others), !!price && !prevPrice && /*#__PURE__*/_react["default"].createElement(_styledPrice.StyledBasicPrice, {
    tag: headingTag,
    size: getResponsiveFontSize(basicPriceConfig),
    type: basicPriceConfig.font.type,
    "data-testid": dataTestId && "".concat(dataTestId, "__basic")
  }, getPriceText(formattedPrice, showCurrentFrom)), !!price && !!prevPrice && /*#__PURE__*/_react["default"].createElement(_styledPrice.StyledSalePriceWrapper, {
    displayFlex: showCurrentFrom,
    size: size
  }, /*#__PURE__*/_react["default"].createElement(_styledPrice.StyledBasicPrice, {
    prevPrice: formattedPrevPrice,
    size: getResponsiveFontSize(basicPriceConfig),
    type: basicPriceConfig.font.type,
    tag: headingTag,
    "data-testid": dataTestId && "".concat(dataTestId, "__basic")
  }, /*#__PURE__*/_react["default"].createElement(_fuseUtils.StyledScreenReaderSpan, null, "Current sale price is "), getPriceText(formattedPrice, showCurrentFrom)), showSave && /*#__PURE__*/_react["default"].createElement(_styledPrice.StyledSavePrice, {
    size: getResponsiveFontSize(savePriceConfig),
    type: savePriceConfig.font.type,
    "data-testid": dataTestId && "".concat(dataTestId, "__save")
  }, "(", getPriceText(formattedSavePrice, showCurrentFrom, true), ")")), !!prevPrice && /*#__PURE__*/_react["default"].createElement(_styledPrice.StyledPrevPrice, {
    size: getResponsiveFontSize(prevPriceConfig),
    type: prevPriceConfig.font.type,
    "data-testid": dataTestId && "".concat(dataTestId, "__prev")
  }, /*#__PURE__*/_react["default"].createElement(_fuseUtils.StyledScreenReaderSpan, null, "Regular price was "), getPriceText(formattedPrevPrice, showPreviousFrom)));
});
Price.propTypes = propTypes;
Price.defaultProps = defaultProps;
var _default = exports["default"] = Price;